import { type InsuranceCorporateIdentity } from "../types";

export function EVMLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient
          id="paint0_linear_33_4905"
          x1="0"
          y1="256"
          x2="512"
          y2="256"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EA5430" />
          <stop offset="1" stopColor="#F8BE2A" />
        </linearGradient>
        <clipPath id="clip0_33_4905">
          <rect
            width="429"
            height="178"
            fill="white"
            transform="translate(42 167)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clip0_33_4905)">
        <path
          d="M382.011 167C357.564 167 335.399 176.893 319.289 192.906C303.211 176.893 281.013 167 256.533 167C232.053 167 209.855 176.893 193.778 192.906C177.667 176.893 155.502 167 130.989 167C81.83 167 42 206.868 42 256C42 305.132 81.8631 345 130.989 345C155.469 345 177.667 335.107 193.745 319.094C209.822 335.107 232.02 345 256.5 345C280.98 345 303.178 335.107 319.255 319.094C335.333 335.107 357.531 345 382.011 345C431.17 345 471 305.132 471 256C471 206.868 431.137 167 382.011 167ZM169.529 291.038C159.671 301.89 145.644 308.11 130.989 308.11C102.274 308.11 78.9189 284.751 78.9189 256.033C78.9189 227.315 102.274 203.957 130.989 203.957C145.644 203.957 159.671 210.177 169.529 221.029C173.267 225.131 173.135 231.484 169.198 235.421L119.51 285.049C123.05 286.472 126.953 287.233 130.989 287.233C139.756 287.233 148.191 283.494 154.113 277.009C157.984 272.741 164.567 272.443 168.834 276.315C173.102 280.186 173.399 286.77 169.529 291.038ZM195.696 305.661C191.826 304.04 189.279 300.235 189.279 296.033V216C189.279 210.243 193.943 205.578 199.699 205.578C205.455 205.578 210.12 210.243 210.12 216V270.888L272.379 208.622C276.448 204.552 283.031 204.552 287.1 208.622C291.169 212.691 291.169 219.275 287.1 223.345L207.043 303.412C204.066 306.389 199.567 307.283 195.696 305.661ZM427.829 296.067C427.829 301.823 423.164 306.488 417.408 306.488C411.652 306.488 406.988 301.823 406.988 296.067V241.178L344.728 303.445C341.784 306.389 337.285 307.283 333.414 305.661C329.544 304.04 326.997 300.235 326.997 296.033V241.178L264.737 303.412C260.701 307.448 254.052 307.448 250.016 303.412C245.98 299.375 245.98 292.725 250.016 288.688L330.04 208.655C333.017 205.677 337.516 204.784 341.387 206.405C345.258 208.026 347.805 211.831 347.805 216.033V270.922L410.064 208.655C413.041 205.677 417.54 204.784 421.411 206.405C425.315 208.026 427.829 211.831 427.829 216.033L427.829 296.067Z"
          fill="white"
        />
        <path
          d="M130.989 224.8C113.787 224.8 99.7603 238.796 99.7603 256.033C99.7603 261.591 101.216 266.819 103.763 271.319L146.273 228.804C141.674 226.223 136.381 224.8 130.989 224.8Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export const EVM: InsuranceCorporateIdentity = {
  id: "evm",
  name: "EVM",
  logo: EVMLogo,
  backgroundColor: "#EA5430",
  textColor: "#FFFFFF",
  wildcard: "evm",
  type: "statutory",
};
